export const ALERT_TRIGGER_LABELS = {
  'connection-lost': 'Disconnected',
  'filter-bypass-detected': 'Bypass active',
  'ro-low-inlet-pressure': 'RO low inlet pressure',
  'ro-low-tank-pressure': 'RO low tank pressure',
  'soft-no-salt-level': 'No salt',
  'soft-low-salt-level': 'Low salt',
  'soft-half-full-salt-level': 'Salt ~50%',
  'filter-near-exhaustion-80-to-90': 'Filter 80% exhausted',
  'filter-near-exhaustion-90-to-95': 'Filter 90% exhausted',
  'filter-near-exhaustion-95-to-100': 'Filter 95% exhausted',
  'filter-exhausted': 'Filter exhausted',
  'potential-clog': 'Potential clog',
  'ro-filter-near-exhaustion-80-to-90': 'RO filter 80% exhausted',
  'ro-filter-near-exhaustion-90-to-95': 'RO filter 90% exhausted',
  'ro-filter-exhausted': 'RO filter exhausted',
};

// Fallback for unknown slugs: "some-thing-here" -> "Some thing here"
export const humanizeAlertTrigger = slug => {
  if (!slug) return 'Unknown';
  const known = ALERT_TRIGGER_LABELS[slug];
  if (known) return known;
  const humanized = slug.replace(/-/g, ' ').trim();
  return humanized.charAt(0).toUpperCase() + humanized.slice(1);
};
